import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../entities';
import { TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { ForgePioHelpjuiceIcon } from './icon';
import { ForgePioHelpjuiceSearchResultIcon } from './search-result-icon';

export const forgePioHelpjuiceConfig: ThirdPartyConfig = {
	displayName: 'Helpjuice by Pio',
	id: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
	resourceType: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
	icon: get3PLogo(ForgePioHelpjuiceIcon, 'ForgePioHelpjuice', 'medium'),
	searchResultIcon: get3PLogo(ForgePioHelpjuiceSearchResultIcon, 'ForgePioHelpjuice', 'large'),
	integrationAri: 'ari:cloud:platform::integration/f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
